module.exports = "/_next/static/files/c8d5d8774f62036fa3b50af455f99c30.png";